// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "app-" + chunkId + "." + {"130":"004fd2b8a47c672c85c2","764":"c8ea87b6d998339913cd"}[chunkId] + ".js";
};